export enum CoreActionsEnum {
  CORE_SET_LOADING = 'CORE_SET_LOADING',
  CORE_SHOW_NOTICE = 'CORE_SHOW_NOTICE',
  CORE_HIDE_NOTICES = 'CORE_HIDE_NOTICES',
  CORE_CHANGE_VIEW = 'CORE_CHANGE_VIEW',
  CORE_SET_HEADER_HEIGHT = 'CORE_SET_HEADER_HEIGHT',
  CORE_GET_LOGIN_PAGE = 'CORE_GET_LOGIN_PAGE',
  CORE_SET_LOGIN_PAGE = 'CORE_SET_LOGIN_PAGE',
}
